import useMediaQueries from 'app/hooks/useMediaQueries';
import { IProject } from 'app/services/responseTypes';
import { CancelIcon } from 'assets/icons';
import OverlayWindow from 'Components/OverlayWindow';
import { useClosePopup } from 'Components/Popups';
import UserBox from 'Components/UserBox';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';

interface ITeamAssigneesModal {
  taxReturn?: IProject;
}

export default function TeamAssigneesModal({ taxReturn }: ITeamAssigneesModal) {
  const { md_down: isMobile } = useMediaQueries();
  const navigate = useNavigate();
  const { isClient, dashboard } = useAuth();
  const closeMenu = useClosePopup();

  return (
    <OverlayWindow
      size=""
      paddingSize="py-2 px-4"
      border=""
      rounded={isMobile ? 'rounded-t-3xl rounded-b-none' : 'rounded-xl'}
    >
      <div>
        <div
          className="cursor-pointer appearance-none background-transparent flex justify-end mb-2 mt-1"
          onClick={closeMenu}
        >
          <CancelIcon />
        </div>
        <div className="text-left text-base text-black font-bold pb-2">
          <p>Team Assignees ({taxReturn?.assignees?.length} )</p>
        </div>
        {taxReturn?.assignees && taxReturn?.assignees[0] ? (
          <div className="grid grid-cols max-h-72 text-left overflow-y-scroll no-scrollbar">
            {taxReturn.assignees?.map((res: any) => (
              <UserBox
                key={res.id}
                user={res}
                onClick={() =>
                  res.profile_type === 'AccountantProfile' &&
                  (isClient
                    ? navigate(`/dashboard/accountant/${res.id}/profileInfo`)
                    : navigate(
                        `/${dashboard}/accountant/${res.id}/profileInfo`,
                      ))
                }
              />
            ))}
          </div>
        ) : (
          <p>No assgined team yet</p>
        )}
      </div>
    </OverlayWindow>
  );
}
